import React, { Component, Fragment } from 'react';
import classnames from 'classnames';

import './CreditCard.css';

class CreditCard extends Component {
  handleSetDefault = (event) => {
    event.preventDefault();

    const { card, onSetDefault } = this.props;
    onSetDefault && onSetDefault(card.id);
  }

  handleRemove = (event) => {
    event.preventDefault();

    const { card, onDelete } = this.props;
    onDelete && onDelete(card.id);
  }

  render() {
    const { card, defaultCard } = this.props;
    const isDefault = defaultCard && defaultCard.id === card.id;

    return (
      <div
        className={classnames('CreditCard payment-method card', {
          default: isDefault
        })}
      >
        <div className="card-top">
          Card ending in {card.last4} <br />
          Exp: {`${card.exp_month}`.padStart(2, '0')}/{card.exp_year}
        </div>

        <div className="card-bottom">
          <i className="fa fa-cc-visa fa-2x pull-right" />
          {isDefault ? (
            <div className="d-inline-block rounded stamp">Default</div>
          ) : (
            <Fragment>
              <a className="card-link" href="#" onClick={this.handleSetDefault}>
                Set Default
              </a>
              <br />
            </Fragment>
          )}
          {/* <a className="card-link" href="#" onClick={this.handleRemove}>
            Remove
          </a> */}
        </div>
      </div>
    );
  }
}

export default CreditCard;



// WEBPACK FOOTER //
// ./src/components/CreditCard/CreditCard.js